import React, { Component } from 'react';
import { changeColorTint } from '../../../styles/utils';
import moment from 'moment';

class NoDataItem extends Component {
  render() {
    return (
      <div className="side-menu-list-obj">
        {/*inner wrapper to generate side color border*/}
        <div className="list-obj-inner-wrapper" style={{ borderLeftColor: '#BC4040' }}>
          <div className="obj-title danger-text">
            {this.props.text || "There isn't any data to show here."}
          </div>
        </div>
      </div>
    );
  }
}

export default NoDataItem;
